"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zipPPGSamples = exports.zipSamples = exports.zipEEGSamples = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const constants_1 = require("../lib/constants");
function zipEEGSamples(eegReadings) {
    const buffer = [];
    let lastTimestamp = null;
    return eegReadings.pipe(operators_1.mergeMap((r) => {
        if (r.timestamp !== lastTimestamp) {
            lastTimestamp = r.timestamp;
            if (buffer.length) {
                const result = rxjs_1.from([[...buffer]]);
                buffer.splice(0, buffer.length, r);
                return result;
            }
        }
        buffer.push(r);
        return rxjs_1.from([]);
    }), operators_1.concat(rxjs_1.from([buffer])), operators_1.mergeMap((rs) => {
        const result = rs[0].samples.map((_, i) => {
            const data = [NaN, NaN, NaN, NaN, NaN]; // default values for 5 channels
            for (const r of rs) {
                data[r.electrode] = r.samples[i];
            }
            return {
                data,
                index: rs[0].index,
                timestamp: rs[0].timestamp + (i * 1000) / constants_1.MUSE_EEG_SAMPLING_RATE,
            };
        });
        return rxjs_1.from(result);
    }));
}
exports.zipEEGSamples = zipEEGSamples;
//TODO: This should become a single general function for both Insai and Muse -> on all data streams
function zipSamples(eegReadings, chNames, samplingRate) {
    const buffer = [];
    let lastTimestamp = null;
    return eegReadings.pipe(operators_1.mergeMap((r) => {
        if (r.timestamp !== lastTimestamp) {
            lastTimestamp = r.timestamp;
            if (buffer.length) {
                const result = rxjs_1.from([[...buffer]]);
                buffer.splice(0, buffer.length, r);
                return result;
            }
        }
        buffer.push(r);
        return rxjs_1.from([]);
    }), operators_1.concat(rxjs_1.from([buffer])), operators_1.mergeMap((rs) => {
        const result = rs[0].samples.map((_, i) => {
            //const data = [NaN, NaN, NaN, NaN, NaN, NaN, NaN, NaN] // default values for 8 channels
            const data = chNames.map(() => NaN);
            for (const r of rs) {
                data[r.channel] = r.samples[i];
            }
            return {
                data,
                index: rs[0].index,
                timestamp: rs[0].timestamp + (i * 1000) / samplingRate,
            };
        });
        return rxjs_1.from(result);
    }));
}
exports.zipSamples = zipSamples;
function zipPPGSamples(ppgReadings) {
    const buffer = [];
    let lastTimestamp = null;
    return ppgReadings.pipe(operators_1.mergeMap((r) => {
        if (r.timestamp !== lastTimestamp) {
            lastTimestamp = r.timestamp;
            if (buffer.length) {
                const result = rxjs_1.from([[...buffer]]);
                buffer.splice(0, buffer.length, r);
                return result;
            }
        }
        buffer.push(r);
        return rxjs_1.from([]);
    }), operators_1.concat(rxjs_1.from([buffer])), operators_1.mergeMap((rs) => {
        const result = rs[0].samples.map((_, i) => {
            const data = [NaN, NaN, NaN]; // default values for 3 channels
            for (const r of rs) {
                data[r.channel] = r.samples[i];
            }
            return {
                data,
                index: rs[0].index,
                timestamp: rs[0].timestamp + (i * 1000) / constants_1.MUSE_PPG_SAMPLING_RATE,
            };
        });
        return rxjs_1.from(result);
    }));
}
exports.zipPPGSamples = zipPPGSamples;
//# sourceMappingURL=zip-samples.js.map